/**
 * Cabeçalho sticky da Tela 2 com tab-nav (scroll-to seção). Convertido do
 * `PersonHeader` do mockup. Tabs visíveis dependem de capability real:
 *   - Appointments → cap `appointments`
 *   - Bubbles → só quando há bubbles (exige `confidentiality-bubbles-full` + dado)
 * Resumos IA aparece sempre (honest-defer: empty state real, Item 338).
 */

export interface PersonTab {
  id: string;
  label: string;
}

export function buildPersonTabs(opts: {
  hasAppointments: boolean;
  hasBubbles: boolean;
  /** Frente B Sessão 3 — aba Fila só p/ tenant com fila (`scheduling-waitlist`). */
  hasWaitlist?: boolean;
  /** S4 PR-b (Item 404 faceta a) — aba Carteira só p/ quem lê `customer-portfolio-read`. */
  hasPortfolio?: boolean;
}): PersonTab[] {
  const tabs: PersonTab[] = [
    { id: 'identity', label: 'Visão geral' },
    { id: 'bonds', label: 'Bonds' },
  ];
  if (opts.hasPortfolio === true) tabs.push({ id: 'carteira', label: 'Carteira' });
  tabs.push({ id: 'conversas', label: 'Conversas' }, { id: 'pendencias', label: 'Pendências' });
  if (opts.hasAppointments) tabs.push({ id: 'appointments', label: 'Agendamentos' });
  if (opts.hasWaitlist === true) tabs.push({ id: 'waitlist', label: 'Fila de espera' });
  tabs.push({ id: 'summaries', label: 'Resumos IA' });
  if (opts.hasBubbles) tabs.push({ id: 'bubbles', label: 'Bubbles' });
  return tabs;
}

export function PersonHeader({
  name,
  subtitle,
  tabs,
  activeTab,
  onTab,
}: {
  name: string;
  subtitle: string;
  tabs: PersonTab[];
  activeTab: string;
  onTab: (id: string) => void;
}): JSX.Element {
  return (
    <div className="person-page__head">
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 'var(--space-3)',
          flexWrap: 'wrap',
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: 'var(--text-3xl)',
            fontWeight: 'var(--fw-semibold)',
            letterSpacing: 'var(--track-tight)',
          }}
        >
          {name}
        </h1>
        <span className="muted mono" style={{ fontSize: 'var(--text-xs)' }}>
          {subtitle}
        </span>
      </div>
      <nav className="person-tabs" aria-label="Seções da pessoa">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            className={'person-tab' + (activeTab === t.id ? ' person-tab--active' : '')}
            onClick={() => {
              onTab(t.id);
            }}
          >
            {t.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
